import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
  CreateInvestmentThesisInput,
  CreateInvestmentThesisSuccessorInput,
  RebindInvestmentThesisIdentityInput,
  UpdateInvestmentThesisInput,
} from 'shared';

import {
  createInvestmentThesis,
  createInvestmentThesisSuccessor,
  rebindInvestmentThesis,
  updateInvestmentThesis,
} from '../../lib/api/endpoints';

import { investmentThesisKeys } from './queries';

function useInvalidateInvestmentTheses() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: investmentThesisKeys.all });
}

export function useCreateInvestmentThesis() {
  const invalidate = useInvalidateInvestmentTheses();
  return useMutation({
    mutationFn: (input: CreateInvestmentThesisInput) => createInvestmentThesis(input),
    onSuccess: invalidate,
  });
}

export function useUpdateInvestmentThesis() {
  const invalidate = useInvalidateInvestmentTheses();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateInvestmentThesisInput }) =>
      updateInvestmentThesis(id, input),
    onSuccess: invalidate,
  });
}

export function useRebindInvestmentThesis() {
  const invalidate = useInvalidateInvestmentTheses();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: RebindInvestmentThesisIdentityInput }) =>
      rebindInvestmentThesis(id, input),
    onSuccess: invalidate,
  });
}

export function useCreateInvestmentThesisSuccessor() {
  const invalidate = useInvalidateInvestmentTheses();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: CreateInvestmentThesisSuccessorInput }) =>
      createInvestmentThesisSuccessor(id, input),
    onSuccess: invalidate,
  });
}
